<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M9.4528 18.4147L3.59998 12.7028L5.48129 10.8673L9.37697 14.6682L17.2455 6.36011L19.2 8.12169L9.4528 18.4147Z" />
</svg>